export default __webpack_public_path__ + "static/media/icon-trash.ce9a5a01.svg";